import { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { openNotification } from "../../utils/saveFile";
import apiDocumentos from "../../api/Documentos/api-documentos";
import getStorageUser from "../../middlewares/GetStorageUser"
import { DownloadFile } from "../../utils/DownloadFile";

interface IProps {
  state: any;
  visualizar: boolean;
  setVisualizar: any;
  tipo?: any;
  tipoDocumento?: any;
}

export const ModalVisualizarDocumentos: React.FC<IProps> = (props: IProps) => {
  const { documento } = props.state;
  const [dataDocumento, setDataDocumento] = useState({ pdf: "" });

  useEffect(() => {
    if (props.visualizar) {

      verDocumentacion();
    }
  }, [props.visualizar]);

  const verDocumentacion = async () => {
    if (documento !== undefined && documento !== null) {
      let extension = documento.split(".");

      if (localStorage.user) {
        const user = getStorageUser()
        if (!user.admin) {
          if (extension[1] !== "pdf") {
            props.setVisualizar(false);
            return openNotification({
              titulo: "Error",
              descripcion: "No puede visualizar documentos que no sean pdf",
              placement: "bottomRight",
            });
          }
        }
      }


      try {
        let response;

        if (props.tipoDocumento === 'terminos') {

          response = await apiDocumentos.consultarArchivosEstaticos(documento)

        } else if (props.tipoDocumento === 'politicasUso') {

          response = await apiDocumentos.consultarArchivosEstaticos(documento)

        } else {
          response = await apiDocumentos.consultarArchivo(documento)
        }

        let mimetype;
        let tipo = documento.split(".");
        var file, fileURL;
        switch (tipo[1]) {
          case "pdf":
          case "PDF":
            mimetype = "application/pdf";
            file = new Blob([response.data], {
              type: mimetype,
            });
            fileURL = URL.createObjectURL(file);
            return setDataDocumento({
              ...dataDocumento,
              pdf: fileURL,
            });
          case "doc":
          case "docx":
          case "DOC":
          case "DOCX":

            mimetype = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            file = new Blob([response.data], {
              type: mimetype,
            });
            fileURL = URL.createObjectURL(file);
            return setDataDocumento({
              ...dataDocumento,
              pdf: fileURL,
            });
          case "xls":
          case "xlsx":
          case "XLS":
          case "SLSX":
            mimetype = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            file = new Blob([response.data], {
              type: mimetype,
            });
            fileURL = URL.createObjectURL(file);
            return setDataDocumento({
              ...dataDocumento,
              pdf: fileURL,
            });
          default:
            return DownloadFile(documento);
        }

      } catch (error) {
        console.log(error);
      }
    } else {
      return openNotification({
        titulo: "Error",
        descripcion: "Ups, no se ha encontrado el archivo",
        placement: "bottomRight",
      });
    }
  };

  const onCancel = () => {
    props.setVisualizar(false)
    return setDataDocumento({ ...dataDocumento, pdf: '' });
  }

  return (
    <Modal
      className="ant-modal-close-x2"

      title={`Previsualización: ${props.state.documento}`}
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={1200}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div>
        {dataDocumento.pdf !== "" ? (
          <embed src={`${dataDocumento.pdf}`} width="100%" height="575px" />
        ) : null}
      </div>
    </Modal>
  );
};
